<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-actions v-if="draftInfo">
    <f7-actions-group>
      <f7-actions-label>{{ draftInfo.title }}</f7-actions-label>
    </f7-actions-group>
    <f7-actions-group>
      <f7-actions-button v-if="menuDraftVariationProp !== 'main'" @click="deleteDraftOnClick" color="red">刪除</f7-actions-button>
      <f7-actions-button @click="navigateToEditPage">編輯</f7-actions-button>
      <f7-actions-button @click="navigateToCopyPage">複製草稿</f7-actions-button>
      <f7-actions-button @click="navigateToReleasePage">發佈</f7-actions-button>
    </f7-actions-group>

    <f7-actions-group>
      <f7-actions-button color="red" bold>取消</f7-actions-button>
    </f7-actions-group>
  </f7-actions>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'MenuDraftActionSheet',
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String
  },
  computed: {
    ...mapState('menuDraftModule', ['menuDraftList']),
    draftInfo () {
      return this.menuDraftList.find(d => d.variation === this.menuDraftVariationProp)
    }
  },
  methods: {
    ...mapActions('menuModule', ['getMenuVariations']),
    ...mapActions('menuDraftModule', ['getMenuDraftList', 'deleteDraft']),
    navigateToEditPage () {
      this.$f7.views.main.router.navigate(`/stores/${this.storeIdProp}/menu-drafts/${this.menuDraftVariationProp}/edit-main`)
    },
    navigateToCopyPage () {
      this.$f7.views.main.router.navigate(`/stores/${this.storeIdProp}/menu-drafts/${this.menuDraftVariationProp}/copy`)
    },
    navigateToReleasePage () {
      this.$f7.views.main.router.navigate(`/stores/${this.storeIdProp}/menu-drafts/${this.menuDraftVariationProp}/release`)
    },
    deleteDraftOnClick () {
      if (this.menuDraftVariationProp === 'main') {
        this.$f7.dialog.alert('主要菜單無法刪除', '菜單受保護')
        return
      }
      this.$f7.dialog.confirm('是否刪除菜單', '刪除菜單', async () => {
        this.deleteDraft(this.menuDraftVariationProp)
      })
    }
  }
}
</script>
